import { Routes, Route } from 'react-router-dom';
import Layout from '../Layout/Layout';
// eslint-disable-next-line import/extensions
import { PolicyProfileMode } from './enum/PolicyProfileMode.enum';
import { PolicyInfoContext, PolicyInfoHook } from './PolicyInfoContext';
import { PolicyProfilePage } from './PolicyProfilePage';
import { PoliciesTable } from './PoliciesTable';
import { QThemeProvider } from '@kw/quokka-ui';

export default function Policies() {
  const {
    policyName,
    policyEnabled,
    policyDescription,
    policyCreatedOn,
    policyFormErrors,
    policyRuleParameters,
    setPolicyName,
    setPolicyEnabled,
    setPolicyDescription,
    setPolicyCreatedOn,
    setPolicyFormErrors,
    setPolicyRuleParameters,
  } = PolicyInfoHook();

  return (
    <PolicyInfoContext.Provider
      value={{
        policyName,
        policyEnabled,
        policyDescription,
        policyCreatedOn,
        policyFormErrors,
        policyRuleParameters,
        setPolicyName,
        setPolicyEnabled,
        setPolicyDescription,
        setPolicyCreatedOn,
        setPolicyFormErrors,
        setPolicyRuleParameters,
      }}
    >
      <QThemeProvider>
        <Routes>
          <Route element={<Layout />}>
            <Route path="create" element={<PolicyProfilePage mode={PolicyProfileMode.CREATE} />} />
            <Route path="edit/:policyId" element={<PolicyProfilePage mode={PolicyProfileMode.EDIT} />} />
            <Route path="view/:policyId" element={<PolicyProfilePage mode={PolicyProfileMode.VIEW} />} />
            <Route path="/" element={<PoliciesTable />} />
          </Route>
        </Routes>
      </QThemeProvider>
    </PolicyInfoContext.Provider>
  );
}
